import React from 'react';

import { Row } from '../../components/Grid/Row';
import { Header } from '../../components/Layout/Header';
import { Content } from '../../components/Layout/Content';
import Favorites from '../Favorites';
import { SearchComboBox } from '../../components/SearchComboBox';

const localFavorites = localStorage.getItem('chronicle-service-favorites');

function Home() {
  return (
    <Row>
      <Header width={12}>
        <h1>ChronicleUI</h1>
      </Header>
      <Content>
        <SearchComboBox />
        {localFavorites && JSON.parse(localFavorites).length > 0 && <Favorites localFavorites={localFavorites} />}
      </Content>
    </Row>
  );
}

export default Home;
